import {BibTipoUsuarioModel} from '@/models/biblioteca/bibtipousuario/bibtipousuario.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class BibTipoUsuarioService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<BibTipoUsuarioModel>>> {
  return api.post <DataSource <BibTipoUsuarioModel>>('/BibTipoUsuario/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(bibTipoUsuario: BibTipoUsuarioModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/BibTipoUsuario', bibTipoUsuario);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/BibTipoUsuario/' + id);
 }

 atualizar(bibTipoUsuario: BibTipoUsuarioModel): Promise<AxiosResponse> {
  return api.put('/BibTipoUsuario', bibTipoUsuario);
 }

 async get(id: number): Promise<BibTipoUsuarioModel> {
  const result = await api.get<BibTipoUsuarioModel>(`/BibTipoUsuario/${id.toString()}`);
  return result.data;
 }
 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/BibTipoUsuario/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }

}
export default new BibTipoUsuarioService();
